import { render } from "./InvestmentConfirmation.vue?vue&type=template&id=034f3d7c"
import script from "./InvestmentConfirmation.vue?vue&type=script&lang=js"
export * from "./InvestmentConfirmation.vue?vue&type=script&lang=js"
script.render = render

export default script